export const LOAD_USER = 'LOAD_USER';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const LOADING = 'LOADING';
export const AUTH_FAIL = 'AUTH_FAIL';
export const HIDE_LOADING = 'HIDE_LOADING';
export const UPDATE_INFO_SUCCESS = 'UPDATE_INFO_SUCCESS';
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const LOAD_ORDERS = 'LOAD_ORDERS';

// Cart types
export const CART_LOAD = 'CART_LOAD';
export const CART_ADD = 'CART_ADD';
export const CART_UPDATE = 'CART_UPDATE';
export const CART_DELETE = 'CART_DELETE';
export const SET_CART_ID = 'SET_CART_ID';
export const CART_SET_TOTAL = 'CART_SET_TOTAL';
